// this file is automatically generated by git.version.js script
export const versions = {version: '0.1.0', revision: '00b1ae2', branch: 'public'};